/**
 * Telling a LOCAL ack apart from a PEER ack.
 *
 * The IndexedDB adapter has to acknowledge writes itself — without it Gun never
 * acks a put while offline and every `gunPutWithTimeout` reports failure even
 * though the data is durably stored on the device. But that ack means only "this device
 * stored it", and Gun's put callback hands both kinds of ack to the same
 * function with the same `{ok: 1}` shape.
 *
 * Conflating them made every write look successful, including ones the relay
 * rejects outright — an unsigned write into someone else's `~<pub>` graph acks
 * `ok` locally, and the relay's `err` ack arrives after the promise has already
 * resolved. So the adapter stamps its own acks and the write helpers treat a
 * local-only ack as "durable here, unconfirmed there".
 *
 * Lives in its own module so both the adapter (which gunClient imports) and
 * gunWrite (which imports gunClient) can use it without an import cycle.
 */

/** Marker field the local store stamps on the acks it emits. */
export const LOCAL_ACK_FLAG = '_localAck';

/** True when this ack came from the local store rather than a peer. */
export function isLocalAck(ack: any): boolean {
  return !!ack && typeof ack === 'object' && (ack as any)[LOCAL_ACK_FLAG] === 1;
}
